module.exports = __webpack_public_path__ + "static/img/carousel-1.241b2b1b.jpg";